import React, { useContext } from "react";
import { UserContext } from "../../stores/UserStore";
import { AppContext } from "../../stores/AppStore";
import Header from "../../components/layout/Header";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import AppLogo from "assets/images/logo.png";

const AppHeader = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { pageTitle, isHeaderVisible } = useContext(AppContext);
  const { authState, signOut, currentUser } = useContext(UserContext);

  const sideMenuSettings = {
    appLogoSrc: AppLogo,
    itemGroups: [
      {
        key: "no-header",
        items: [
          {
            key: "no-header-entry",
            icon: "apps",
            label: "Home",
            onClick: () => history.push("/"),
          },
        ],
      },
    ],
  };

  if (currentUser && currentUser.roles.UPLOAD_JOBS !== undefined) {
    sideMenuSettings.itemGroups.splice(1, 0, {
      key: "upload",
      items: [
        {
          key: "upload",
          icon: "apps",
          label: "Upload",
          onClick: () => history.push("/job-upload"),
        },
      ],
    });
  }

  const userSettings = {
    username: currentUser ? currentUser.name : currentUser,
    options: [
      {
        key: "version",
        label: "v" + process.env.REACT_APP_VERSION,
        onClick: () => {},
      },
      {
        key: "sign-out",
        label: t("Sign Out"),
        onClick: signOut,
        divider: true,
      },
    ],
  };

  const home = {
    onClick: () => (window.location.href = process.env.REACT_APP_HOME_URL),
  };

  const apps =
    currentUser &&
    currentUser.applications &&
    currentUser.applications.map((app) => {
      return {
        key: app.id,
        label: app.label,
        iconSrc: app.icon,
        onClick: () => (window.location.href = app.link),
      };
    });

  return isHeaderVisible && authState === "SIGNED_IN" ? (
    <Header
      title={pageTitle}
      homeIcon={home}
      appIconSrc={AppLogo}
      userSettings={userSettings}
      sideMenuSettings={sideMenuSettings}
      apps={apps}
      warningLink={process.env.REACT_APP_TALLY_NEW_URL || "#"}
      warningTopText={t("warningBanner.topText")}
      warningLinkText={t("warningBanner.linkText")}
      warningBottomText={t("warningBanner.bottomText")}
    />
  ) : null;
};

export default AppHeader;
